import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  SvgIcon,
} from '@material-ui/core'
import { mdiHome, mdiHomeGroup } from '@mdi/js'
import { withStyles } from '@material-ui/core/styles'

import UnitSelect from './CommunityUnitSelectContainer'

const GRANT_TYPE = {
  community: 'community',
  unit: 'unit',
}

const DEFAULT_STATE = {
  isFormValid: false,
  grantType: GRANT_TYPE.unit,
  unitIds: [],
}

class CommunityGrantDoorAccessDialog extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* passed props */
    communityId: PropTypes.number.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onGrantCommunityAccess: PropTypes.func.isRequired,
    onGrantUnitAccess: PropTypes.func.isRequired,
  }

  static styles = () => ({
    radioLabel: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 5,
      },
    },
  })

  state = DEFAULT_STATE

  onClose = () => {
    this.setState(DEFAULT_STATE)
    this.props.onClose()
  }

  onSubmit = () => {
    if (this.state.grantType === GRANT_TYPE.community) {
      this.props.onGrantCommunityAccess()
    } else if (this.state.unitIds.length) {
      this.props.onGrantUnitAccess(this.state.unitIds)
    }
  }

  handleUnitChange = (event) => {
    this.setState({
      isFormValid: event.target.value.length > 0,
      unitIds: event.target.value,
    })
  }

  handleRadioChange = (event) => {
    const selectedGrantType = event.target.value

    this.setState({
      grantType: event.target.value,
      unitIds: [],
    })

    if (selectedGrantType === GRANT_TYPE.unit) {
      this.setState({ isFormValid: false })
    } else {
      this.setState({ isFormValid: true })
    }
  }

  render() {
    const { classes } = this.props

    return (
      <Dialog
        open
        onClose={this.onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.dialogTitle}
        </DialogTitle>
        <DialogContent>
          <RadioGroup
            aria-label="grant-type"
            name="grant-type"
            value={this.state.grantType}
            onChange={this.handleRadioChange}
          >
            <FormControlLabel
              value={GRANT_TYPE.community}
              control={<Radio color="primary" />}
              label={(
                <div className={classes.radioLabel}>
                  <SvgIcon>
                    <path d={mdiHomeGroup} />
                  </SvgIcon>
                  <p>Community-wide</p>
                </div>
              )}
            />
            <FormControlLabel
              value={GRANT_TYPE.unit}
              control={<Radio color="primary" />}
              label={(
                <div className={classes.radioLabel}>
                  <SvgIcon>
                    <path d={mdiHome} />
                  </SvgIcon>
                  Unit
                </div>
              )}
            />
          </RadioGroup>
          { (this.state.grantType === GRANT_TYPE.unit)
            && (
              <UnitSelect
                communityId={this.props.communityId}
                onChange={this.handleUnitChange}
                unitIds={this.state.unitIds}
              />
            )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onSubmit}
            disabled={!this.state.isFormValid}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default withStyles(CommunityGrantDoorAccessDialog.styles)(CommunityGrantDoorAccessDialog)
